import * as THREE from "three";

export const engravingsEnabled = () =>
  new URLSearchParams(location.search).get("engravings") !== "off";

export function engraveWall(surface) {
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = 2048;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Wall engraving canvas is unavailable");
  context.fillStyle = "#000";
  context.fillRect(0, 0, 2048, 2048);
  const texture = new THREE.CanvasTexture(canvas);
  texture.anisotropy = 4;
  {
    context.strokeStyle = "#999";
    context.lineWidth = 4;
    context.lineCap = "round";
    context.beginPath();
    context.arc(440, 660, 160, -.8, 1.7);
    context.moveTo(260, 755); context.lineTo(760, 755);
    context.moveTo(440, 470); context.lineTo(440, 860);
    context.moveTo(423, 660); context.lineTo(457, 660);
    context.moveTo(440, 643); context.lineTo(440, 677);
    context.moveTo(850, 1550); context.lineTo(1150, 1550);
    context.lineTo(1150, 1780);
    context.moveTo(890, 1590); context.lineTo(1070, 1590);
    for (let index = 0; index < 5; index++) {
      const x = 880 + index * 42;
      context.moveTo(x, 1542); context.lineTo(x, 1558);
    }
    context.stroke();
    context.save();
    context.translate(825, 1958);
    context.scale(.45, .45);
    context.translate(-1160, -1928);
    context.strokeStyle = "#006600";
    context.lineWidth = 4;
    context.beginPath();
    context.moveTo(1160, 1970);
    context.lineTo(1166, 1928);
    context.bezierCurveTo(1200, 1923, 1203, 1943, 1165, 1947);
    context.bezierCurveTo(1206, 1938, 1209, 1969, 1160, 1970);
    context.moveTo(1206, 1970);
    context.lineTo(1212, 1928);
    context.bezierCurveTo(1247, 1924, 1247, 1947, 1210, 1949);
    context.lineTo(1239, 1973);
    context.stroke();
    context.restore();
    texture.needsUpdate = true;
  }

  surface.onBeforeCompile = shader => {
    shader.uniforms.uEngraving = { value: texture };
    shader.vertexShader = shader.vertexShader
      .replace("#include <common>", "#include <common>\nvarying vec3 vEngravingPosition;")
      .replace("#include <begin_vertex>", "#include <begin_vertex>\nvEngravingPosition = position;");
    shader.fragmentShader = shader.fragmentShader
      .replace("#include <common>", `#include <common>
        uniform sampler2D uEngraving;
        varying vec3 vEngravingPosition;
        float engravingMask(vec2 uv) {
          if (any(lessThan(uv, vec2(0.0))) || any(greaterThan(uv, vec2(1.0)))) return 0.0;
          return texture2D(uEngraving, uv).r;
        }`)
      .replace("#include <roughnessmap_fragment>", `#include <roughnessmap_fragment>
        vec2 engravingUv = vec2((vEngravingPosition.x + 4.25) / 8.5,
          (vEngravingPosition.y + 12.5) / 8.5 - 0.12);
        vec2 signatureUv = engravingUv + vec2(0.0, 0.12);
        vec4 engravingInk = texture2D(uEngraving, clamp(signatureUv, 0.0, 1.0));
        float signature = max(0.0, engravingInk.g - engravingInk.r)
          * step(4.49, vEngravingPosition.z);
        float engraving = max(engravingMask(engravingUv), signature)
          * step(4.49, vEngravingPosition.z);
        diffuseColor.rgb *= 1.0 - engraving * 0.22;
        diffuseColor.rgb = mix(diffuseColor.rgb, vec3(0.19), signature);
        roughnessFactor = mix(roughnessFactor, 0.76, engraving * 0.65);`)
      .replace("#include <normal_fragment_maps>", `#include <normal_fragment_maps>
        float engravingDepth = -0.018 * engraving;
        normal = perturbNormalArb(-vViewPosition, normal,
          vec2(dFdx(engravingDepth), dFdy(engravingDepth)), faceDirection);`);
  };
  surface.customProgramCacheKey = () => "mindgame-wall-engraving-v1";
  return () => {
    texture.dispose();
  };
}
